import { render } from "./listItems.vue?vue&type=template&id=08212fa2&ts=true"
import script from "./listItems.vue?vue&type=script&lang=ts"
export * from "./listItems.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__